import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useUserAuth } from "../lib/userAuth";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useUserAuth() || {};
    const { refresh: refreshAdmin } = useAuth() || {};
    const processedRef = useRef(false);

    useEffect(() => {
        if (processedRef.current) return;
        processedRef.current = true;

        (async () => {
            const hash = window.location.hash || "";
            const params = new URLSearchParams(hash.replace(/^#/, ""));
            const sessionId = params.get("session_id");

            if (!sessionId) {
                nav("/", { replace: true });
                return;
            }

            try {
                const { data } = await api.post(
                    "/auth/google/session",
                    null,
                    { headers: { "X-Session-ID": sessionId } },
                );
                if (setUser) setUser(data);

                let dest = "/";
                try {
                    dest = sessionStorage.getItem("sd_auth_return") || "/";
                    sessionStorage.removeItem("sd_auth_return");
                } catch (_) {}
                if (data?.role === "admin") {
                    // Populate AdminAuthProvider state before Protected renders.
                    if (refreshAdmin) await refreshAdmin();
                    if (dest === "/admin/login" || dest === "/") dest = "/admin";
                }
                nav(dest, { replace: true, state: { user: data } });
            } catch (err) {
                nav("/admin/login?error=oauth", { replace: true });
            }
        })();
    }, [nav, setUser, refreshAdmin]);

    return (
        <div
            className="grid min-h-screen place-items-center bg-oat text-ink"
            data-testid="auth-callback"
        >
            <div className="flex flex-col items-center gap-4">
                <Loader2 className="h-8 w-8 animate-spin text-coral" />
                <div className="text-xs uppercase tracking-[0.22em] text-ink/60">
                    Signing you in…
                </div>
            </div>
        </div>
    );
}
